<template>
  <div class="content">
    <div class="control_bar top">
      <div class="search">
        {{ title }}
      </div>
    </div>

    <div class="content_main">
      <div class="margin_bottom">{{ infoLabel }}</div>

      <div class="flex margin_bottom">
        <div>
          <div>{{ startLabel }}</div>
          <div class="indent">{{ inputData.startDateTime }}</div>
        </div>
        <span style="margin: 30px 10px 10px 10px">~</span>
        <div>
          <div>{{ endLabel }}</div>
          <div class="indent">{{ inputData.endDateTime }}</div>
        </div>
      </div>

      <div>{{ maintenanceMessageLabel }}</div>
      <div class="margin_bottom indent message_area">
        {{ inputData.message }}
      </div>

      <div>{{ tenantListLabel }}</div>

      <div class="table_area margin_bottom" v-if="!selectAllFlag">
        <table class="content_title" rules="rows">
          <tr class="items_table">
            <td class="table_contents">
              <label>{{ corporationNameLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantIdLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantNameLabel }}</label>
            </td>
          </tr>
        </table>

        <div class="table_scroll">
          <table class="items_table" rules="rows">
            <tr
              class="item_table_row"
              v-for="tenant in selectedTenantList"
              :key="tenant.companyId"
            >
              <td class="table_contents">
                <label>{{ tenant.corporationName }}</label>
              </td>
              <td class="table_contents">
                <label>{{ tenant.companyId }}</label>
              </td>
              <td class="table_contents">
                <label>{{ tenant.companyName }}</label>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="indent" v-if="selectAllFlag">
        {{ selectAllLabel }}
      </div>

      <div class="bottom_button_area">
        <input
          type="button"
          :value="cancelButton"
          class="cancel_button"
          @click="cancel"
        />
        <input
          type="button"
          :value="addButton"
          class="finish_button"
          @click="addMaintenance"
        />
      </div>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="completeWord" @close="toList">
      </completeModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showFailureModal">
      <completeModalWindow :question="failureWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import pagenation from '../../../pagenation.vue'
import datepicker from 'vue-flatpickr-component'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      title: 'メンテナンス予定追加確認',
      infoLabel: 'メンテナンス予定日時',
      startLabel: '開始',
      endLabel: '終了',
      maintenanceMessageLabel: 'メンテナンス画面表示メッセージ',
      tenantSelectLabel: 'メンテナンス実施テナント選択',
      tenantListLabel: '配信テナント',
      selectAllLabel:
        '全体通知 ※個別のチェックに関係なく全体に通知します。後から作成されたテナントにも通知されます。',
      corporationNameLabel: '法人名',
      tenantIdLabel: 'テナントID',
      tenantNameLabel: 'テナント名',
      cancelButton: 'キャンセル',
      addButton: '追加',
      completeWord: '追加しました。',
      showCompleteModal: false,
      failureWord: '',
      showFailureModal: false,
      showloadingModal: false
    }
  },
  components: {
    pagenation,
    datepicker,
    completeModalWindow,
    loadingModalWindow
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    inputData() {
      var data = {
        startDateTime: '',
        endDateTime: '',
        message: ''
      }
      var inputData = this.$store.state.maintenance.addData
      var s = new Date(inputData.startDateTime)
      data.startDateTime =
        s.getFullYear() +
        '/' +
        this.padZero(s.getMonth() + 1) +
        '/' +
        this.padZero(s.getDate()) +
        '  ' +
        this.padZero(s.getHours()) +
        ':' +
        this.padZero(s.getMinutes()) +
        ':' +
        this.padZero(s.getSeconds())
      var e = new Date(inputData.endDateTime)
      data.endDateTime =
        e.getFullYear() +
        '/' +
        this.padZero(e.getMonth() + 1) +
        '/' +
        this.padZero(e.getDate()) +
        '  ' +
        this.padZero(e.getHours()) +
        ':' +
        this.padZero(e.getMinutes()) +
        ':' +
        this.padZero(e.getSeconds())
      data.message = inputData.message
      return data
    },
    selectedTenantList() {
      return this.$store.state.maintenance.selectedTenantList
    },
    selectAllFlag() {
      return this.$store.state.maintenance.selectAllFlag
    }
  },
  methods: {
    cancel(e) {
      this.$router.push('/master/maintenance/add')
    },
    async addMaintenance() {
      this.showloadingModal = true
      var inputData = this.$store.state.maintenance.addData
      var selectedTenantIdList = this.selectedTenantList.map(tenant => {
        return {companyId: tenant.companyId}
      })
      try {
        await this.$store.dispatch('maintenance/addMaintenance', {
          message: inputData.message,
          startDateTime: inputData.startDateTime,
          endDateTime: inputData.endDateTime,
          allFlag: this.selectAllFlag,
          companyIdList: this.selectAllFlag ? [] : selectedTenantIdList
        })
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650002
        this.createErrorMessage(error, eventNumber, 'MSGCRD0112')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    toList() {
      this.showCompleteModal = false
      this.$router.push('/master/maintenance')
    },
    close() {
      this.showCompleteModal = false
      this.showFailureModal = false
      this.$store.state.maintenance.selectAllFlag = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    padZero(num) {
      return num < 10 ? '0' + num : num
    }
  }
}
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.start_datepicker,
.end_datepicker {
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  padding: 0 0 0 10px;
  height: 30px;
  font-size: 14px;
  width: calc(100% - 30px);
}
.bottom_button_area {
  display: flex;
  justify-content: end;
  margin: 100px 20px 20px 20px;
}
.control_bar {
  background-color: #bbffff;
}
.content,
.bottom {
  width: calc(100% - 262px);
}
.content_title,
.items_table {
  background-color: #ddffff;
  width: 100%;
}
.content_main {
  height: calc(100% - 110px);
  position: relative;
  background-color: #fff;
  padding: 26px 32px;
  overflow-y: scroll;
}
.table_contents {
  table-layout: fixed;
  width: 30%;
}
.table_area {
  border: 1px solid #a6e3e0;
}
.message_area {
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/maintenance/maintenanceAddConfirm.vue